<div class="home">
  <div class="decorative-blob blob-1"></div>
  <div class="decorative-blob blob-2"></div>

  <div class="section1">
    <div class="left-section">
      <div class="heading">
        Transform Your Hiring with <span class="o-clr">AI-Powered Assessments</span>
      </div>
      <div class="sec1-content">
        Evaluate candidates intelligently with automated assessments powered by AI. Generate relevant questions, test
        coding skills,
        and identify top talent faster - all before scheduling interviews. Save time, reduce costs, and make data-driven
        hiring decisions
        with our comprehensive assessment platform.
      </div>
      <div class="cta-row">
        <button mat-flat-button color="primary" class="start-chip" (click)="gotoLogin()">
          TRY FOR FREE <mat-icon iconPositionEnd>arrow_right_alt</mat-icon>
        </button>
        <button mat-stroked-button color="primary" class="demo-chip" (click)="bookDemo()">
          GET A FREE DEMO <mat-icon iconPositionEnd>arrow_forward</mat-icon>
        </button>
      </div>
      <div class="cta-caption">
        <mat-icon>credit_card_off</mat-icon>
        <span>Start free trial - No credit card required</span>
      </div>
    </div>
    <img src="../../assets/home-icon1.png" alt="Evaltrix AI hero illustration" class="hero-image">
  </div>

  <div class="content">
    <div class="features-short">
      <div class="heading">Key Product Features</div>
      <div class="sub-heading">What you get with Evaltrix</div>
      <ul class="features-grid" role="list">
        <li class="feature-chip" *ngFor="let f of featuresShort; let i = index" role="link" tabindex="0"
          (click)="goToFeature(i)" (keydown.enter)="goToFeature(i)" (keydown.space)="goToFeature(i)"
          [attr.aria-label]="f.label">
          <mat-icon class="icon">{{ f.icon }}</mat-icon>
          <span class="label">{{ f.label }}</span>
        </li>
      </ul>
    </div>

    <div class="how-it-works-section">
      <div class="heading">How <span> Evaltrix </span> works</div>

      <!-- consolidated: using only detailed step cards below -->

      <div class="step-container">
        <div class="step" [ngClass]="{'even-step': i % 2 === 0, 'odd-step': i % 2 !== 0, 'current': i === 0}"
          *ngFor="let step of howItWorksDetailedSteps; let i = index" [style.grid-row-start]="i + 1">
          <div class="icon l-dot">
            <a class="dot" [href]="'#hiw-step-' + (i + 1)" [attr.aria-label]="'STEP ' + (i + 1 | number:'2.0-0')"
              [attr.title]="'STEP ' + (i + 1 | number:'2.0-0')">
              <span class="visually-hidden">STEP {{ i + 1 | number:'2.0-0' }}</span>
            </a>
            <div class="rail-node">{{ i + 1 | number:'2.0-0' }}</div>
          </div>
          <div class="left-section" [attr.id]="'hiw-step-' + (i + 1)">
            <div class="step-label">STEP {{ i + 1 | number:'2.0-0' }}</div>
            <div class="content-card">
              <div class="step-icon">
                <ng-container *ngIf="isMaterialIcon(step.icon); else imageIcon">
                  <mat-icon>{{ step.icon }}</mat-icon>
                </ng-container>
                <ng-template #imageIcon>
                  <img [src]="'../../assets/' + step.icon" [alt]="step.title">
                </ng-template>
              </div>
              <div class="heading step-heading">{{ step.title }}</div>
              <div class="sub-heading">{{ step.intro }}</div>
              <ng-container *ngFor="let group of step.groups">
                <div class="groups">
                  <div class="label" *ngIf="group.label">{{ group.label }}</div>
                  <ul>
                    <li *ngFor="let item of group.items">{{ item }}</li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="faq-section">
      <div class="heading">A Few Facts About <span class="h-text"> Hiring </span></div>
      <div class="subheading">The modern hiring process is broken. Here's why traditional methods fail.</div>

      <!-- Group 1: Resume Reality (facts 1-3) -->
      <div class="facts-group resume">
        <div class="group-title"><span class="marker"></span>Resume Reality</div>
        <div class="group-desc">The truth about what recruiters face when screening applications</div>
      </div>
      <div class="facts-grid cluster resume">
        <div class="fact-card" *ngFor="let f of (factsDetailed | slice:0:3); let i = index">
          <div class="num-badge">{{ (i + 1) | number:'2.0-0' }}</div>
          <div class="f-icon"><mat-icon>{{ f.icon }}</mat-icon></div>
          <div class="fact-title">{{ f.title }}</div>
          <div class="fact-text">{{ f.text }}</div>
        </div>
      </div>

      <!-- Group 2: Screening Challenges (facts 4-7) -->
      <div class="facts-group screening">
        <div class="group-title"><span class="marker"></span>Screening Challenges</div>
        <div class="group-desc">Why the initial filtering process wastes valuable time and resources</div>
      </div>
      <div class="facts-grid cluster screening">
        <div class="fact-card" *ngFor="let f of (factsDetailed | slice:3:7); let i = index">
          <div class="num-badge">{{ (i + 4) | number:'2.0-0' }}</div>
          <div class="f-icon"><mat-icon>{{ f.icon }}</mat-icon></div>
          <div class="fact-title">{{ f.title }}</div>
          <div class="fact-text">{{ f.text }}</div>
        </div>
      </div>

      <!-- Group 3: Assessment Problems (facts 8-10) -->
      <div class="facts-group assessment">
        <div class="group-title"><span class="marker"></span>Assessment Problems</div>
        <div class="group-desc">The costly reality of poor evaluation methods in technical hiring</div>
      </div>
      <div class="facts-grid cluster assessment">
        <div class="fact-card" *ngFor="let f of (factsDetailed | slice:7:10); let i = index">
          <div class="num-badge">{{ (i + 8) | number:'2.0-0' }}</div>
          <div class="f-icon"><mat-icon>{{ f.icon }}</mat-icon></div>
          <div class="fact-title">{{ f.title }}</div>
          <div class="fact-text">{{ f.text }}</div>
        </div>
      </div>
    </div>

    <div class="customers-section">
      <div class="customers-heading">Trusted by Leading Organizations</div>
      <div class="customers-container">
        <div class="customer-logo" *ngFor="let customer of customers">
          <img [src]="'../../assets/' + customer.logo" [alt]="customer.name + ' logo'">
        </div>
      </div>
    </div>

    <!-- <app-home-price></app-home-price> -->

    <div class="blog-section">
      <div class="b-heading">Help Centre</div>
      <div class="b-sub-heading">Everything you need to know about Evaltrix</div>
      <div class="container">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
          <div ngxSlickItem *ngFor="let article of totalArticles;let index = index" class="slide help-card" role="link"
            tabindex="0" [attr.aria-label]="article?.attributes?.title" (click)="gotoHelp(article)"
            (keydown.enter)="gotoHelp(article)" (keydown.space)="gotoHelp(article)">
            <div class="category-chip" *ngIf="article?.attributes?.category?.data?.attributes?.name as cat">
              {{ cat }}
            </div>
            <div class="title">
              {{article?.attributes?.title}}
            </div>
            <div class="excerpt" *ngIf="getExcerpt(article) as ex">
              {{ ex }}
            </div>
            <div class="read-time">{{ getReadTime(article) }}</div>
            <div class="author-details">
              <img *ngIf="article?.attributes?.author?.data?.attributes?.icon?.data?.attributes?.url"
                [src]="'https://help.evaltrix.com' + article?.attributes?.author?.data?.attributes?.icon?.data?.attributes?.url"
                [alt]="(article?.attributes?.author?.data?.attributes?.first_name || '') + ' ' + (article?.attributes?.author?.data?.attributes?.last_name || '')"
                class="author-icon" />

              <div class="author-info">
                <div
                  *ngIf="article?.attributes?.author?.data?.attributes?.first_name || article?.attributes?.author?.data?.attributes?.last_name">
                  <span>Written by </span>
                  <span class="author-names"> {{article?.attributes?.author?.data?.attributes?.first_name + ' ' +
                    article?.attributes?.author?.data?.attributes?.last_name}}</span>
                </div>
                <div class="updated">
                  {{calculateDiff(article.attributes?.updatedAt) > 7 ? 'Updated ' + (article.attributes?.updatedAt |
                  date:'longDate') : 'Updated recently' }}
                </div>
              </div>
            </div>
            <div class="read-more">Read more <mat-icon>arrow_forward</mat-icon></div>
          </div>
        </ngx-slick-carousel>
      </div>
    </div>
  </div>
</div>